import { useRef } from 'react';
import { HeaderRef } from '../components/Header';
import type { ChartsRef } from '../components/chat';

interface UseHomePageRefsReturn {
  customerOverviewRef: React.RefObject<{ init: () => void }>;
  headerRef: React.RefObject<HeaderRef>;
  chartsRef: React.RefObject<ChartsRef>;
  viewportRef: React.RefObject<HTMLDivElement>;
  chartsViewportRef: React.RefObject<HTMLDivElement>;
}

/**
 * 管理 HomePage 的所有 refs
 */
export function useHomePageRefs(): UseHomePageRefsReturn {
  const customerOverviewRef = useRef<{ init: () => void }>(null);
  const headerRef = useRef<HeaderRef>(null);
  const chartsRef = useRef<ChartsRef>(null);
  const viewportRef = useRef<HTMLDivElement>(null);
  const chartsViewportRef = useRef<HTMLDivElement>(null);

  return {
    customerOverviewRef,
    headerRef,
    chartsRef,
    viewportRef,
    chartsViewportRef
  };
}
